export default "__VITE_ASSET__35727214__"